(function () {
  var COOKIENAME = 'TEScookieLawCookie';
  var COOKIEINFO = 'Welcome, this site uses cookies. <a href="https://www.tes.com/us/privacy-policy" style="color:white;">Read our privacy policy</a>';

  var PANEL_CLASSES = 'cookielaw-panel text-center padding-top-xs padding-bottom-xs padding-left-lg padding-right-lg';
  var INFO_CLASSES = 'text--white padding-right-sm padding-left-sm';
  var CLOSE_CLASSES = 'padding-left-lg';
  var CLOSE_CLASSES_MOBILE = 'tes-btn tes-btn--outline tes-btn--block';

  function createPanel() {
    var wrapper = document.createElement('div');
    wrapper.className = PANEL_CLASSES;
    wrapper.style.backgroundColor = '#44A4F6';
    wrapper.style.position = 'fixed';
    wrapper.style.bottom = '0';
    wrapper.style.width = '100%';
    wrapper.style.zIndex = '10';
    wrapper.style.transition = 'transform ease-out 200ms';

    var info = document.createElement('span');
    info.className = INFO_CLASSES;
    info.innerHTML = COOKIEINFO;
    wrapper.appendChild(info);

    var close = document.createElement('span');
    close.innerHTML = '<span class="hidden-xs"><a href="#" style="color:white;" class="' + CLOSE_CLASSES + '">Close</a> <i style="cursor:pointer;position:relative;top:-1px;" class="icon-close-button icon-white"></i></span><div class="visible-xs padding-top-sm"><span class="' + CLOSE_CLASSES_MOBILE + '">Close</span></div>';
    wrapper.appendChild(close);

    document.body.insertBefore(wrapper, document.body.firstChild);

    close.addEventListener('click', destroyPanel);

    function destroyPanel(evt) {
      evt.preventDefault();
      Cookies.set(COOKIENAME, 'true');
      wrapper.style.transform = 'translateY(100%)';
      setTimeout(function () {
        wrapper.parentNode.removeChild(wrapper);
      }, 600);
    }
  }

  var alreadyLoggedIn = Cookies.get('TESCookieUser');
  var cookieLawCookie = Cookies.get(COOKIENAME);
  var isGB = Cookies.get('siteCountry').toLowerCase() === 'gb';
  if (isGB && !cookieLawCookie && !alreadyLoggedIn) {
    createPanel();
  }
}());
